<template>
  <el-footer>
    <el-row type="flex" class="row-bg" justify="end">
      <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
          <p>Developed by <img src="@/assets/img/cryptomarket-blanc.png" /></p>
      </el-col>
    </el-row>
  </el-footer>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  }
};
</script>
    <style scoped>
footer {
  /* height: inherit !important; */
  background-color: #1e1e1e;
  color: white;
  padding: 1.8vh 0;
  p, img{
    vertical-align: middle;
  }
  p{
    margin: 0;
  }
  img{
    max-height: 3vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/merchants/Footer.vue